import "core-js/modules/es.array.includes.js";
import { getProductTypeById } from '@finect/front-resources/Products';
import { getResourcePath } from '@finect/front-core/Routes';
export var getReviewPath = function getReviewPath(theme, product, review) {
  var productType = getProductTypeById(product.subtype);
  var isIIC = ['iic'].includes(productType.category);
  var scene = isIIC ? 'FundReview' : 'ProductReview';
  var model = product.hasOwnProperty('entity') ? product : {
    subtype: product.subtype,
    entity: product
  };
  var path = getResourcePath(theme, scene, {
    idReview: review.id,
    isin: isIIC ? model.entity.isin : '',
    alias: model.entity.alias,
    typeSlug: productType.slug
  });
  return path;
};
export var getReviewsPath = function getReviewsPath(theme, product) {
  var productType = getProductTypeById(product.subtype);
  var scene = ['iic'].includes(productType.category) ? 'FundReviews' : 'ProductReviews';
  return getResourcePath(theme, scene, {
    typeSlug: productType.slug,
    productTypeSlug: productType.slug,
    isin: product.isin,
    alias: product.alias,
    productSlug: product.alias
  });
};
export var getWriteReviewPath = function getWriteReviewPath(theme, product) {
  var productType = getProductTypeById(product.subtype);
  var scene = ['iic'].includes(productType.category) ? 'FundWriteReview' : 'ProductWriteReview';
  return getResourcePath(theme, scene, {
    typeSlug: productType.slug,
    productTypeSlug: productType.slug,
    isin: product.isin,
    alias: product.alias,
    productSlug: product.alias
  });
};